import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Col, Row, Table, Grid, Divider } from "antd";
import { PageName, SearchContainer, SearchIcon, SearchInput, SearchButton, StyledCard } from './style';
import { MyText } from "../../components";
import { SearchOutlined } from "@ant-design/icons";
import {useTranslation} from "react-i18next";
const isMobile = window.innerWidth < 768;

export const PrivacyPolicyPage = () => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [searchParams, setSearchParams] = useSearchParams();

 

  

  return (
    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <MyText color='#0A033C' size={32} weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', textAlign: 'center' }}>
              {t("privacyPolicy")} 
            </MyText>
          </Col>

          <Col span={24}>
            <StyledCard>
            <MyText color='#0A033C' size={32} weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
              {t("privacyPolicy")}
            </MyText>
              </StyledCard>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
